import isValidUrl from '@atlassian/jira-common-util-is-url/src/index.tsx';

// eslint-disable-next-line no-script-url
export const forbiddenScheme = 'javascript:';

export const isAllowed = (value: string | null) => {
	if (value === '' || value === null) return true;
	if (isValidUrl(value)) return true;
	if (!value.startsWith(forbiddenScheme)) return true;
	return false;
};
